<div class="container" data-cy="rebook_or_change_page">
  <page-title text="BOOKING.REBOOK.TITLE" (backChange)="back()"></page-title>
  <div *ngIf="booking">
    <div class="row" *featureRebooking>
      <div class="col-12" *ngIf="booking.isStonechip">
        <div class="font-bold" translate>BOOKING.REBOOK.LINK.TITLE</div>
        <div translate>BOOKING.REBOOK.LINK.DESCRIPTION</div>
        <div class="mt-20"><a [rebook]="booking.key" translate>BOOKING.REBOOK.LINK.LINK_TEXT</a></div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="font-bold" *featureRebooking translate>BOOKING.REBOOK.CHANGES.TITLE</div>
        <div class="font-bold" *featureRebookingDisabled translate>BOOKING.REBOOK.CHANGES.TITLE_OLD</div>
        <div>{{"BOOKING.REBOOK.CHANGES.DESCRIPTION" | translate}} {{"QUESTIONS" | translate}}</div>
        <div class="form-group mt-20" [class.required]="isFieldInvalid()">
          <label for="message" translate>MESSAGE</label>
          <textarea class="form-control" rows="3" id="message" [class.invalid]="isFieldInvalid()"
                    [formControl]="message"></textarea>
        </div>
        <div class="form-group">
          <input placeholder="{{'INPUT_EMAIL' | translate}}" type="text" class="form-control" [formControl]="email">
        </div>
      </div>
    </div>
    <div class="row mt-20">
      <div class="col-12">
        <button type="button" class="btn btn-medium" (click)="send()">
          {{"SEND" | translate}}
          <i *ngIf="sendInProgress" class="fa fa-spinner fa-spin"></i>
        </button>
      </div>
    </div>
  </div>
</div>
